export default {
  type: {
    INCOME: {
      label: "Entrada",
      color: "success",
      icon: "mdi-arrow-down-bold",
    },
    EXPENSE: {
      label: "Saída",
      color: "error",
      icon: "mdi-arrow-up-bold",
    },
  },
  status: {
    PENDING: {
      label: "Pendente",
      color: "warning",
      icon: "mdi-clock-outline",
    },
    SETTLED: {
      label: "Recebido",
      color: "success",
      icon: "mdi-check",
    },
    CANCELLED: {
      label: "Cancelado",
      color: "grey",
      icon: "mdi-cancel",
    },
  },
  settledStatusLabel: {
    INCOME: "Recebido",
    EXPENSE: "Pago",
  },
  dreLines: [
    { value: "GROSS_REVENUE", text: "Receita operacional bruta", nature: "INCOME" },
    { value: "DEDUCTIONS", text: "Deduções da receita", nature: "EXPENSE" },
    { value: "COSTS", text: "Custos dos serviços", nature: "EXPENSE" },
    { value: "OPERATING_EXPENSES", text: "Despesas operacionais", nature: "EXPENSE" },
    { value: "FINANCIAL_INCOME", text: "Receitas financeiras", nature: "INCOME" },
    { value: "FINANCIAL_EXPENSES", text: "Despesas financeiras", nature: "EXPENSE" },
    { value: "OTHER_INCOME", text: "Outras receitas", nature: "INCOME" },
    { value: "OTHER_EXPENSES", text: "Outras despesas", nature: "EXPENSE" },
    { value: "INCOME_TAX", text: "IR/CSLL", nature: "EXPENSE" },
    { value: "UNCLASSIFIED", text: "Não classificado", nature: null },
  ],
};
